<section id="hero-section" class="hero-section">
  <div
    class="w-100 h-100 green-primary-linear-gradient-background position-relative d-flex justify-content-center align-items-center z-1"
  >
    <div class="w-80 position-relative z-3 pe-none">
      <div class="d-flex flex-column w-100 w-lg-75">
        <h1 class="fs-1-text text-white fw-semibold mb-3">
          Les données immobilières les plus récentes, les plus fiables,
          directement issues des actes notariés
        </h1>
        <p class="fs-4-text text-white w-75 w-lg-50">
          Notaires, experts, agents : ne laissez pas vos estimations
          immobilières se baser sur des données périmées
        </p>
        <div class="d-flex align-items-center gap-3 mt-2">
          <img
            src="assets/perval-icons/triangle_left.svg"
            alt="icone triangle"
          />
          <div
            class="d-flex flex-column align-items-start flex-xxl-row justify-content-xxl-center align-items-xxl-center gap-xxl-2 mobile-text rotating-text"
          >
            <div class="fixed-container">
              <p class="m-0 fw-bold">En toute confiance pour</p>
            </div>
            <div class="active-container">
              <p class="m-0 active-text">estimer un bien immobilier</p>
              <p class="m-0 active-text">justifier le prix de vente</p>
              <p class="m-0 active-text">sécuriser votre avis de valeur</p>
              <p class="m-0 opacity-0">sécuriser votre avis de valeur</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-none d-lg-flex align-items-end justify-content-start position-absolute bottom-0 start-0 h-100 z-2 w-75 w-lg-50 overflow-hidden"
    >
      <img class="v" src="assets/perval-icons/v.svg" alt="icone v" />
      <img class="a" src="assets/perval-icons/a.svg" alt="icone a" />
    </div>
    <app-hero-section-box
      class="position-absolute hero-section-box z-4"
    ></app-hero-section-box>
  </div>
</section>
